import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manager-residency-requests" }

import { ref, watch } from 'vue';
import type { Request, PermissionFormData, FiltersListResponse, ApiStatusResponse, RawApplication, UpdateStatusPayload } from './types';
import { useRequestData } from './composables/useRequestData';
import { useRequestFilter } from './composables/useRequestFilter';
import RequestsList from './components/RequestsList.vue';
import RequestDetail from './components/RequestDetail.vue';
import {
  showStcErrorNotification,
  showStcSuccessNotification,
} from '@/js/components/stc-notification';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const selectedRequest = ref<Request | null>(null);
const currentView = ref<'list' | 'detail'>('list');

const {
  requests,
  loading,
  error,
  loadRequests,
  loadRequestDetails,
  updateStatus,
  sendReply,
  exportRequests,
} = useRequestData();

const { filter, loading: filtersLoading, error: filtersLoadingError } = useRequestFilter();

watch(error, (err) => {
  if (err) {
    showStcErrorNotification(err);
  }
});

async function handleParamsChange(params: {
  page: number;
  filter: Partial<Record<keyof FiltersListResponse, string>> & {
    dateFrom: string | null;
    dateTo: string | null;
  };
  search: string;
}) {
  await loadRequests(params);
}

async function handleExport(params: {
  filter: Partial<Record<keyof FiltersListResponse, string>> & {
    dateFrom: string | null;
    dateTo: string | null;
  };
  search: string;
}) {
  await exportRequests(params);
}

async function openRequest(request: RawApplication): Promise<void> {
  const fullRequest = await loadRequestDetails(request.id);
  if (fullRequest) {
    selectedRequest.value = fullRequest;
    currentView.value = 'detail';
  } else {
    showStcErrorNotification('Не удалось загрузить детали заявки');
  }
}

function closeDetail(): void {
  selectedRequest.value = null;
}

function goBack() {
  currentView.value = 'list';
  selectedRequest.value = null;
}

async function onSubmitReply({ comment, files }: PermissionFormData): Promise<void> {
  if (!selectedRequest.value?.id) return;

  try {
    await sendReply(selectedRequest.value.id, { comment, files });
    showStcSuccessNotification('Ответ успешно отправлен');
  } catch {
    showStcErrorNotification('Не удалось отправить ответ');
  }
}

async function onStatusUpdated({
  status,
  text,
}: {
  status?: ApiStatusResponse;
  text?: string;
}): Promise<void> {
  if (!selectedRequest.value) return;
  const requestParams: UpdateStatusPayload = {};
  if (status?.id) {
    requestParams.status = status;
  }
  if (text) {
    requestParams.admin_comment = text;
  }

  try {
    await updateStatus(selectedRequest.value.id, requestParams);
    showStcSuccessNotification('Данные успешно сохранены');
    const updatedRequest = await loadRequestDetails(selectedRequest.value.id);
    if (updatedRequest) {
      selectedRequest.value = updatedRequest;
    }
  } catch (err) {
    showStcErrorNotification('Ошибка обновления статуса');
    console.error('Ошибка обновления статуса:', err);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentView.value === 'list')
      ? (_openBlock(), _createBlock(RequestsList, {
          key: 0,
          requests: _unref(requests).data,
          pagination: _unref(requests).pagination,
          loading: _unref(loading),
          filter: { ..._unref(filter), filtersLoading: _unref(filtersLoading), filtersLoadingError: _unref(filtersLoadingError) },
          onParamsChange: handleParamsChange,
          onRowClick: openRequest,
          onExportClick: handleExport
        }, null, 8, ["requests", "pagination", "loading", "filter"]))
      : (currentView.value === 'detail' && selectedRequest.value)
        ? (_openBlock(), _createBlock(RequestDetail, {
            key: 1,
            request: selectedRequest.value,
            loading: _unref(loading),
            ref: "requestDetailRef",
            onClose: closeDetail,
            onStatusUpdated: onStatusUpdated,
            onReply: onSubmitReply,
            onBack: goBack
          }, null, 8, ["request", "loading"]))
        : _createCommentVNode("", true)
  ]))
}
}

})